/**
 * Properties for the getBase64 function.
 *
 * @property fileType - The MIME type of the file (e.g., 'image/png').
 * @property base64 - The base64-encoded string of the file data.
 * @property clear - If true, returns a plain data URI; otherwise, returns a CSS url() string.
 */
export interface GetBase64Props {
  fileType?: string;
  base64?: string;
  clear?: boolean;
}

/**
 * Generates a base64 data URI or CSS url() string from file type and base64 data.
 *
 * @param getBase64Props - The properties containing fileType, base64 string, and clear flag.
 * @returns A data URI string or CSS url() string, or undefined if required data is missing.
 */
export function getBase64(getBase64Props: GetBase64Props): string | undefined {
  const { fileType, base64, clear = false } = getBase64Props;

  if (!base64 || !fileType) {
    return undefined;
  }
  if (clear) {
    return `data:${fileType + ';base64,' + base64}`;
  }
  return `url('data:${fileType + ';base64,' + base64}')`;
}
